
<button mat-icon-button (click)="btnClickedHandler()">
  <mat-icon>delete</mat-icon>
</button>